export default __webpack_public_path__ + "static/media/guide-n.00bdc0e6.svg";